(function () {
    "use strict";

    angular.module("app").controller("ClearanceOverviewController", ClearanceOverviewController);

    ClearanceOverviewController.$inject = ["$rootScope", "infiniteScrollDataSourceFactory", "controllerDecorator", "codesService", "enumService", "screeningService",];
    function ClearanceOverviewController($rootScope, infiniteScrollDataSourceFactory, controllerDecorator, codesService, enumService, screeningService) {
        const vm = Object.assign(this, {
            ExportDossiers,
            SetRowStyle,
            GetDetailsString,
            DownloadHabilBVL,
            GetCertificate,
            OpenPersonDossier,
            ReportPerson,
        });
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        vm.SetLoadingState(false);

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(vm.Api.GetClearanceOverviewPaged, (v) => vm.IsLoadingRequests = v);

            vm.Utils.invoke(codesService.loadAllCodes, codes => {
                vm.codeVMTypes = codes.find(c => c.Key === "VMTypes").Value;
                vm.codeIVMLevels = codes.find(c => c.Key === "IVMLevels").Value;
            });

            const pageAndSort = vm.DataSource.GetPageAndSort();

            if (pageAndSort.SortBy.length > 0) {
                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "DateEndClearance";
                vm.sortReverse = false;
            }
        }

        function GetDetailsString(details) {
            if (!details)
                return null;

            return details.map(x => `${vm.codeVMTypes.find(t => t.Key == x.TypeCode).Value} ${vm.codeIVMLevels.find(t => t.Key == x.LevelCode).Value}`).join(" / ");
        }

        function DownloadHabilBVL(clearance) {
            vm.SetLoadingState(true);

            vm.File.DownloadBVL(clearance, () => vm.SetLoadingState(false));
        }

        function GetCertificate(clearance) {
            vm.SetLoadingState(true);

            vm.File.DownloadCertificate(clearance, () => vm.SetLoadingState(false));
        }

        function ExportDossiers() {
            vm.SetLoadingState(true);

            const filter = vm.DataSource.GetFilter();

            vm.Api.GetClearancesExporting(
                { Filter: filter },
                vm.File.saveExport,
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        /**
         * Calculates a styling class for the items in the overview.
         * Cases
         * - Deleted -> deleted class
         * - Expiration date has passed -> expired class
         * - Expiring within 12 months -> expiring class
         * - Clearance is still valid for at least 12 months -> valid class
         * @param {any} clearance The clearance to check
         * @returns a class used for styling entries
         */
        function SetRowStyle(clearance) {
            if (!clearance)
                return "";

            if (clearance.Deleted)
                return "deleted";

            if (!clearance.StillValid)
                return "overview-expired";

            if (habilCommon.dateUtils.isExpiring(clearance.DateEndClearance, 12))
                return "overview-expiring";

            return "overview-valid";
        }

        function OpenPersonDossier(id) {
            if (!id)
                return;

            vm.Navigator.OpenDossierPerson(id, false);
        };

        function ReportPerson(clearance) {
            const screening = {
                RequestId: clearance.RequestPublicId,
                TypeCode: enumService.ScreeningTypeCode.PersonReinvestigation,
                ResultCode: enumService.ScreeningResultCode.Report,
                Attachments: [],
            };

            const $creationScope = $rootScope.$new(true);

            Object.assign($creationScope, {
                isBusy: false,
                personName: `${clearance.Firstnames ?? ""} ${clearance.Name ?? ""}`.trim() ?? clearance.ReferenceNumber,
                screening,
                codeScreeningResults: $rootScope.codeScreeningResults,
                addFiles,
                deleteFile,
            });

            const options = {
                onEscape: true,
                scope: $creationScope,
                title: vm.getTranslation("Screening_Additional_Report"),
                templateHtml: getReportPersonTemplate(),
                buttons: {
                    ok: {
                        label: vm.getTranslation("Button_Confirm"),
                        className: "btn-primary",
                        callback: () => {
                            if (!$creationScope.screeningResultReasonForm.$valid) {
                                vm.ShowError(`${vm.getTranslation("Screening_Result_Description_Required")}: ${vm.getTranslation("Screening_Result_ResultCode_Reason")}`);
                                return false;
                            }

                            screeningService.createScreening(screening, () => {
                                vm.ShowSuccess(vm.getTranslation("Screening_Created"));
                            });
                        },
                    },
                    cancel: {
                        label: vm.getTranslation("Button_Cancel"),
                        className: "btn-default",
                        callback: () => {
                            $creationScope.SecurityIncident = null;
                        },
                    },
                },
                onHidden: () => {
                    // Cleanup the scope when the modal closes.
                    $creationScope.$destroy();
                }
            };

            vm.Dialog.Custom(options);

            function addFiles(files) {
                screening.Attachments.push(...files);
            }

            function deleteFile(attachment) {
                const index = screening.Attachments.indexOf(attachment);
                screening.Attachments.splice(index, 1);
            }
        };

        initialize();

        function getReportPersonTemplate() {
            return `
            <div>
                <p i18n="Screening_Additional_Report_Info"></p>
                <p i18n="Screening_Additional_Report_ModalInfo"></p>
                <div class="row">
                    <label i18n="Person_role_INV"></label>
                </div>
                <div class="row">
                    <span>{{personName}}</span>
                </div>
                <div class="row space-above">
                    <label i18n="Screening_Result_ResultCode"></label>
                </div>
                <div class="row">
                    <span>{{screening.ResultCode | codeValue:codeScreeningResults}}</span>
                </div>
                <ng-form name="screeningResultReasonForm">
                    <div class="row space-above">
                        <label i18n="Screening_Result_ResultCode_Reason"></label>
                    </div>
                    <div class="row">
                        <textarea id="reason" name="reason" class="form-control"
                                    rows="5"
                                    placeholder="{{'Screening_Result_ResultCode_Reason_Info' | habilTranslation}}"
                                    style="resize: vertical; min-height: 5em;"
                                    ng-model="reason"
                                    ng-required="true"
                                    ng-disabled="isBusy"></textarea>
                        <fodbz-validation fodbz-errors="screeningResultReasonForm.reason.$error"
                                            fodbz-role="Alert"
                                            form-error-required="{{'Screening_Result_Description_Required' | habilTranslation}}" />
                    </div>
                </ng-form>
            </div>

            <div class="row">
                <habil-file-picker file-type="936"
                                    allow-multiple="true"
                                    button-class="btn-primary btn-small space-above"
                                    on-file-selected="addFiles(attachments)">
                    <i class="fa fa-paperclip"></i> {{'Upload_Name' | habilTranslation}}
                </habil-file-picker>
            </div>

            <div ng-if="screening.Attachments && screening.Attachments.length > 0">
                <div class="row">
                    <div class="badge" style="font-weight: inherit" ng-repeat="attachment in screening.Attachments"
                        ng-if="!attachment.Deleted">
                        <span>{{attachment.Name}}&nbsp;({{attachment.FileSize | fileSize}})</span>
                        <button type="button" style="background: none; background-color: none; border: none; border-radius: 50%;" ng-click="deleteFile(attachment)"><i class="fa fa-xmark"></i></button>
                    </div>
                </div>
            </div>`;
        }
    }
})();